export const WALLET_TYPE = {
  LEDGER: "ledger",
  ICONEX: "iconex",
} as const;

export type WalletType = typeof WALLET_TYPE[keyof typeof WALLET_TYPE]; 